export const TX_SUCCESSFUL = 'TX_SUCCESSFUL';
export const ETH_REFRESHED = 'ETH_REFRESHED';
export const RETRIVED_GT = 'RETRIVED_GT';
export const RETRIVED_WILLS = 'RETRIVED_WILLS';
export const COMMITTING_CHANGING_MP = 'COMMITTING_CHANGING_MP';
export const COMMITTING_DEAL = 'COMMITTING_DEAL';
export const CONFIRMED_DEAL = 'CONFIRMED_DEAL';
export const COMMITTED_DEAL = 'COMMITTED_DEAL';
